import { Injectable } from '@angular/core';

@Injectable()
export class AppInfoService {
  constructor() {}

  public get title() {
    return '覺風單一登錄窗口';
  }

  public get currentYear() {
    return new Date().getFullYear();
  }
}
